// Назви рядків декларації J0200126 (за бланком xsd_all/254863/J0200126.pdf) — для перегляду і пояснень
export const ROW_TITLES = [
  ["1.1", "R11", "Операції на митній території України за основною ставкою (20 %)"],
  ["1.2", "R12", "Операції за ставкою 7 %"],
  ["1.3", "R13", "Операції за ставкою 14 %"],
  ["9", "R90", "Усього податкових зобов'язань"],
  ["10.1", "R101", "Придбання з ПДВ на митній території України — основна ставка"],
  ["10.2", "R102", "Придбання — ставка 7 %"],
  ["10.3", "R103", "Придбання — ставка 14 %"],
  ["11.1", "R111", "Ввезені на митну територію України товари — основна ставка"],
  ["11.2", "R112", "Ввезені товари — ставка 7 %"],
  ["11.3", "R113", "Ввезені товари — ставка 14 %"],
  ["14", "R140", "Коригування податкового кредиту (розрахунки коригування)"],
  ["16.1", "R161", "Значення рядка 21 попереднього звітного періоду"],
  ["17", "R170", "Усього податкового кредиту"],
  ["18", "R180", "До сплати до бюджету (р.9 − р.17, позитивне значення)"],
  ["19", "R190", "Від'ємне значення (р.17 − р.9)"],
  ["19.1", "R191", "Перевищення від'ємного значення над сумою за п.200-1.3"],
  ["20", "R200", "Від'ємне значення, що не перевищує суму за п.200-1.3"],
  ["20.3", "R203", "Зараховується до податкового кредиту наступного періоду"],
  ["21", "R210", "Залишок від'ємного значення — переноситься в р.16.1 наступного періоду"],
];
